import { Delete, Edit } from '@mui/icons-material';
import { CircularProgress, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { ISSOEntityModel } from '../../../../../service/sso/interface/ISSOEntityModel';
import { Colors } from '../../../../design/color/Colors';

interface ISSOProvidersTableProperties {
  providersList: ISSOEntityModel[];
  onEdit: (provider: ISSOEntityModel) => void;
  onDelete: (provider: ISSOEntityModel) => void;
}

const StatusDot = ({ alive }: { alive?: boolean }) => {
  if (alive === undefined) return <CircularProgress size={14} />;
  return (
    <Tooltip title={alive ? 'Доступен' : 'Недоступен'}>
      <span
        style={{
          display: 'inline-block',
          width: 14,
          height: 14,
          borderRadius: '50%',
          backgroundColor: alive ? Colors.positiveActive || '#4caf50' : Colors.negativeActive || '#f44336',
        }}
      />
    </Tooltip>
  );
};

export const SSOProvidersTable = observer(({ providersList = [], onEdit, onDelete }: ISSOProvidersTableProperties) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Название</TableCell>
            <TableCell align="center">Статус</TableCell>
            <TableCell align="right">Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {providersList.map((provider) => (
            <TableRow key={provider.id} hover>
              <TableCell>{provider.name}</TableCell>
              <TableCell align="center">
                <StatusDot alive={provider.isAlive} />
              </TableCell>
              <TableCell align="right">
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    onEdit?.(provider);
                  }}
                >
                  <Edit fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  color="error"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete?.(provider);
                  }}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          {providersList.length === 0 && (
            <TableRow>
              <TableCell colSpan={3} align="center">
                Нет SSO-провайдеров
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
});
